<div class="full top-bg"></div>

<mat-card style="height: 200px; width: 600px;margin: 195px auto;">
  <div style="text-align: center;">Logout ....</div>
  <mat-progress-bar mode="query" style="height: 25px; margin-top: 25px;"></mat-progress-bar>
  <img src="../../../assets/images/logout.svg" style="width: 63px; margin-left: 50%; margin-top: 21px;">
</mat-card>
